import { styled } from '@mui/material'

export const PillWrapper = styled('div')(({ theme, PillSize }) => ({ // eslint-disable-line
  '& .MuiChip-label': {
    fontWeight: 600,
    fontSize: PillSize === 'Large' ? '15px' : '14px',
    lineHeight: '19px',
    padding: '7px 10px',
    transition: 'background-color 0.05s ease, color 0.05s ease 0.05s',
  },
  '& .MuiChip-filled': {
    border: '1px solid rgba(0, 83, 160, 0.7)',
  },
  '& .MuiChip-filled:hover': {
    backgroundColor: theme.palette.primary.main,
  },
  '& .MuiChip-root': {
    padding: PillSize === 'Large' ? '20px 0' : '0',
    borderRadius: PillSize === 'Large' ? '32px' : '16px',
  },
  [theme.breakpoints.down('md')]: {
    '& .MuiChip-root': {
      width: '100%',
    },
  },
}))
